const getOrgActiveFeatures = state => {
  return state.orgActiveFeatures;
};

export default { getOrgActiveFeatures };
